<!--
 * @Author: YuanYuan
 * @Date: 2025-05-21 15:30:03
 * @LastEditTime: 2025-12-18 15:34:05
 * @Description: 顶部菜单+左侧菜单+右侧头+右侧内容
-->
<template>
  <div class="headerbar-page">
    <div class="headerbar-page-header">
      <slot name="header"></slot>
    </div>
    <div class="headerbar-page_bottom">
      <aside class="headerbar-page_bottom__nav" :class="[menuToggle&&'is-retract']">
        <LeftMenu :show-product-switch="false" :static-menu-data="menuData" />
      </aside>
      <section class="headerbar-page_bottom__content" :class="[menuToggle&&'is-retract']">
        <component :is="routeMeta.noScrollbar?'div':'el-scrollbar'" :class="routeMeta.noScrollbar?'h-full':'com-scrollbar'">
          <slot></slot>
        </component>
      </section>
      <div class="menu-toggle" :class="[menuToggle&&'is-retract']" @click="handleClick">
        <i class="ws-icon-d-arrow-left"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, computed } from 'vue'
import LeftMenu from '@/components/LeftMenu'
import $const from '@/constants'
import { hasPermission } from "@/utils/base";


const $vm = getCurrentInstance().proxy

const routeMeta = computed(() => $vm.$route.meta)

const menuToggle = computed({
  get() {
    return $vm.$store.getters['csec/menuToggle']
  },
  set(val) {
    $vm.$store.commit('csec/SET_MENU_TOGGLE', val)
  }
})

const menuData = computed(() => {
  const data = $const['Common/StaticMenuData'].find(item => item.code === routeMeta.value.leftMenuCode)
  const result = data.children.filter(item => hasPermission(item.permission))
  return result || []
})

const handleClick = () => {
  menuToggle.value = !menuToggle.value
}
</script>

<style lang="scss" scoped>
$headerHeight: 60px;
$navWidth: 214px;
$transitionTime: .3s;
.headerbar-page{
  height: 100%;
  &-header{
    height: $headerHeight;
    background-color: #fff;
    border-bottom: 1px solid #d9d9d9;
  }
  &_bottom{
    display: flex;
    height: calc(100% - $headerHeight);
    position: relative;
    &__nav{
      min-width: $navWidth;
      width: $navWidth;
      background-color: #fff;
      border-right: 1px solid #d9d9d9;
      z-index: 5;
      position: relative;
      left: 0;
      transition: all $transitionTime;
      &.is-retract{
        left: -$navWidth;
        overflow: hidden;
      }
    }
    &__content{
      position: absolute;
      height: 100%;
      right: 0;
      left: $navWidth;
      transition: left $transitionTime;
      background-color: #f0f7ff;
      &.is-retract{
        left: 0;
      }
    }
    .menu-toggle{
      position: absolute;
      width: 20px;
      height: 40px;
      z-index: 5;
      color: $ws-gray-7;
      font-size: 16px;
      bottom: 0;
      left: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: #fff;
      transition: all $transitionTime;
      &.is-retract{
        transform: rotateY(180deg);
        transform-origin: left;
        box-shadow: 5px 0px 15px 0px rgba(73,72,117,0.3);
      }
    }
  }
}
</style>
